// import Accardion from './components/accardion.js';
// const accardion1 = new Accardion('.accardion-1', {
// });
// const accardion2 = new Accardion('.accardion-2', {
// });
// const accardion3 = new Accardion('.accardion-3', {
// });
// const accardion4 = new Accardion('.accardion-4', {
// });
// const accardion5 = new Accardion('.accardion-5', {
// });

import './components/portfolios';

import './components/sliders';

import './components/ya_map';

import './components/scrollToTop';
